<template>
  <div class="amap-wrapper">
    <el-amap class="amap-box" ref="map" :zoom="zoom" :center="center" :events="events">
      <template v-if="zoom>14">
        <el-amap-circle
          v-for="(item,index) of circles"
          :key="'circle-'+index"
          :center="item.center"
          :radius="item.radius"
          :fill-opacity="item.fillOpacity"
          :fill-color="item.fillColor"
          :stroke-weight="item.strokeWeight"
          :stroke-color="item.strokeColor"
          :z-index="item.zIndex"
        ></el-amap-circle>
        <el-amap-text
          :text="content.text"
          :offset="content.offset"
          :position="content.position"
          :key="content.text"
        ></el-amap-text>
      </template>
      <el-amap-marker v-if="zoom<16" :position="marker.position"></el-amap-marker>
    </el-amap>
  </div>
</template>

<script>
import Vue from "vue";
import VueAMap from "vue-amap";

Vue.use(VueAMap);
VueAMap.initAMapApiLoader({
  key: "136b7682fa9c8f3ba0b616ce3130267c",
  plugin: [
    "Autocomplete",
    "PlaceSearch",
    "Scale",
    "OverView",
    "ToolBar",
    "MapType",
    "PolyEditor",
    "AMap.CircleEditor"
  ],
  // 默认高德 sdk 版本为 1.4.4
  v: "1.4.15"
});
AMap.plugin(["AMap.CircleEditor"]);

export default {
  data() {
    return {
      zoom: 16,
      center: [],
      circles: [
        {
          center: [],
          radius: 14,
          fillOpacity: 0.5,
          fillColor: "	#3366FF",
          strokeWeight: 3,
          strokeColor: "#FFFFFF",
          zIndex: 20
        },
        {
          center: [],
          radius: 100,
          fillOpacity: 0.2,
          fillColor: "	#1E90FF",
          strokeWeight: 0,
          strokeColor: "#FFFFFF",
          zIndex: 12
        }
      ],
      content: {
        position: [],
        text: `<div class='local'>
          <p class='title'>{{name_en}}</p>
          <h2>{{name_ch}}</h2>
          <p class='underline'></p>
          <p class='contact'>地址：{{detail_address}}<br/>
            电话：{{tel}}<br/>
            传真：{{fax}}<br/>
            邮箱：{{email}}
            </p>
            </div>`,
        offset: [250, 20]
      },
      marker: {
        position: []
      },
      events: {
        zoomchange: $event => {
          this.zoom = this.$refs.map.$$getInstance().getZoom();
        }
      }
    };
  },
  created() {
    this.initBasicConfig();
  },
  methods: {
    initBasicConfig() {
      let config = this.$cache.get("basicConfig");
      if (config) {
        this.center = [config.lng, config.lat];
        this.content.position = this.center;
        this.circles.forEach(_ => {
          _.center = this.center;
        });
        this.marker.position = this.center;
        this.content.text = this.content.text.replace(/{{(.*)}}/g, (m, n) => {
          return config[n];
        });
      }
    }
  }
};
</script>

<style lang="less">
.amap-wrapper {
  width: 1200px;
  height: 640px;
  margin: 0 auto;
  .amap-box {
    width: 1200px;
    height: 640px;
    margin: 0 auto;
    .amap-overlay-text-container {
    padding: 24px 38px 24px 38px;
    .local {
      .title {
        font-size: 14px;
        color: #999999;
        line-height: 14px;
        margin-bottom: 8px;
      }
      h2 {
        font-size: 26px;
        font-weight: 500;
        color: #333333;
        line-height: 26px;
      }
      .underline {
        width: 24px;
        height: 2px;
        background: #e60616;
        margin: 16px 0 11px 0;
      }
      .contact {
        font-size: 16px;
        color: #555555;
        line-height: 28px;
      }
    }
  }
  }
}
</style>